import * as utils from './utils';

const API_URL = utils.baseUrl('api');

export default class ApiClient {
    constructor(endpoint) {
        this.endpoint = endpoint;
    }

    get(endpoint, cb, error) {
        this.request('GET', endpoint, cb, error);
    }

    post(endpoint, body, cb, error) {
        this.request('POST', endpoint, cb, error, body);
    }

    patch(endpoint, body, cb, error) {
        this.request('PATCH', endpoint, cb, error, body);
    }

    delete(endpoint, cb, error) {
        this.request('DELETE', endpoint, cb, error);
    }

    getEndpointURL(endpoint) {
        return `${API_URL}${this.endpoint ? '/' + this.endpoint : ''}${endpoint ? '/' + endpoint : ''}`;
    }

    request(type, endpoint, cb, error, body) {
        var request = new XMLHttpRequest();

        request.open(type, this.getEndpointURL(endpoint), true);

        request.withCredentials = true;

        request.onreadystatechange = function () {
            if (request.readyState === XMLHttpRequest.DONE) {
                if (request.status === 200) {
                    var response = request.responseText;
                    switch (request.getResponseHeader('Content-Type').split(';')[0]) {
                        case 'application/json':
                            response = JSON.parse(response);
                            break;
                    }

                    cb && cb(response);
                } else {
                    if (typeof error !== 'function') console.log(request.responseText);

                    error && error(request.responseText);
                }
            }
        };
        request.send(body ? JSON.stringify(body) : null);
    }
}
